
// Update object
export const updateObject = (oldObject: any, updatedProperties: any): any => ({
	...oldObject,
	...updatedProperties
});